import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, useAttrs } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { zbuContactEdit, zbuContactAdd } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'

const __default__ = { name: 'ContactsModal' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  contactRefId: {
    type: String
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const attrs = useAttrs()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<ClueManage['contact']>({})
const props = __props
const emit = __emit
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: ClueManage['contact']) => {
  form.value = row ? cloneDeep(row) : {}
  visible.value = !visible.value
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    if (attrs.onSubmit && typeof attrs.onSubmit === 'function') {
      attrs.onSubmit(form.value, (res: any) => {
        loading.value = false
      })
      return
    }
    try {
      if (form.value?.id) {
        await zbuContactEdit(form.value)
        success('edit')
        message.success('编辑成功')
      } else {
        await zbuContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        success('add')
        message.success('新增成功')
      }
      visible.value = false
    } catch (error) {}
    loading.value = false
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
    title: form.value.id ? '编辑' : '新增',
    class: "clueMerge",
    width: "870px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: form.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    rules: [
            {
              required: true,
              message: '请输入'
            },
            {
              validator: _unref(concatNameValidate)
            }
          ],
                    label: "联系人名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, { label: "性别" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.sex,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sex) = $event)),
                        placeholder: "请选择",
                        options: _unref(dataConfig).genderEnum,
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "角色" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.jobRole,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.jobRole) = $event)),
                        placeholder: "请选择",
                        options: _unref(dataConfig).linkRoleTypeEnum,
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "mobile",
                    label: "手机号",
                    rules: [
            {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.mobile,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.mobile) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "email",
                    label: "邮箱",
                    rules: [
            {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.email,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "wechat",
                    label: "微信号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.wechat,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.wechat) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "qq",
                    label: "QQ号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.qq,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.qq) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "tel",
                    label: "固定电话",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.tel,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.tel) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "备注",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.remark,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.remark) = $event)),
                        maxlength: 2000,
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})